import { useState, useEffect } from 'react';
import { Drawer, useTranslation } from '@nextgen-web-framework/all';
import {
  FilterOption,
  IppPlanCMSResponseType,
  PaymentApi,
  PaymentOption,
  PmpProjection,
} from '@commerce-payment-webcomponents/sdk';
import { cmsApi } from '@commerce-webcomponents/sdk';
import { ErrorCard, Errors } from '@commerce-webcomponents/ui';
import { ProductType } from '../types/enums';
import instalmentDetailsDrawerProps from '../types/propTypes';
import { Images } from '../../../../common/Constant';
import { PaymentLoaderType } from '../../../payment-loader/types/enums';
import { PaymentLoader } from '../../../payment-loader/PaymentLoader';
import styles from './InstalmentDetailsDrawer.module.scss';

export const InstalmentDetailsDrawer = ({ onCloseDrawer, productId, pIPP }: instalmentDetailsDrawerProps) => {
  const t = useTranslation();
  const configs = ConfigService.getConfigs();
  const errorImageUrl = Images.IPP_NO_PLANS;
  const assetsBasePath = configs.NEXT_ASSETS_BASE_PATH as string;
  const [cmsResponsePlanInfo, setCmsResponsePlanInfo] = useState<IppPlanCMSResponseType[]>([]);
  const [showErrorCard, setShowErrorCard] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    //Make an Api call
    setShowLoader(true);
    fetchPaymentOption();
  }, []);

  const fetchPaymentOption = async () => {
    const filterOption = {
      product: [
        {
          type: ProductType.VARIANT,
          id: productId,
        },
      ],
    };
    const paymentOptions: PaymentOption[] = await PaymentApi.getPaymentOptions(
      filterOption as FilterOption,
      pIPP ? PmpProjection.Pipp : PmpProjection.Ipp,
    );
    if (paymentOptions?.length) {
      //making call for content stack
      const planIds: (string | undefined)[] = [];
      paymentOptions[0]?.additionalInfo?.plans?.forEach((planObj) => planIds.push(`"${planObj.id?.toString()}"`));
      planIds.length && fetchContentStackPlans(planIds);
    } else {
      setShowLoader(false);
      setShowErrorCard(true);
    }
  };

  const fetchContentStackPlans = async (planIds: (string | undefined)[]) => {
    const cmsResponse = (await cmsApi.fetchAllContent({
      uId: 'instalment_payment_plan',
      params: [
        {
          key: 'query',
          value: `{"plan_id":{"$in":[${planIds}]}}`,
        },
      ],
    })) as IppPlanCMSResponseType[];
    if (cmsResponse?.length) {
      setCmsResponsePlanInfo(cmsResponse);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setShowErrorCard(true);
    }
  };

  return (
    <div className={styles['ipp-drawer-container']}>
      <Drawer
        header={t('payment.instalmentDetails.drawer.title')}
        onClose={() => onCloseDrawer(false)}
        closeOnBackdropClick
        closeIcon
        bottomGap={0}
        className={styles['instalment-drawer-body']}
      >
        {showLoader ? (
          <PaymentLoader loaderType={PaymentLoaderType.INSTALMENT_DETAILS} />
        ) : (
          cmsResponsePlanInfo?.map((planObj, index) => (
            <div key={planObj?.plan_id} className={index === 0 ? styles['plans-first-element'] : ''}>
              <div className={styles['plans-title']}>{planObj?.plan_title}</div>
              <div
                className={styles['plan-description']}
                dangerouslySetInnerHTML={{
                  __html: planObj?.plan_description || '',
                }}
              />
            </div>
          ))
        )}

        {showErrorCard && (
          <ErrorCard
            className={styles['ipp-no-stores-card']}
            title={t('payment.errorCard.noIppPlans')}
            imageUrl={`${assetsBasePath}${errorImageUrl}`}
            type={Errors?.General}
            customImageClass={styles['ipp-no-stores-card-image']}
            customCtaComponent={<></>}
          />
        )}
      </Drawer>
    </div>
  );
};
